module.exports = __webpack_public_path__ + "img/pr_slow2.f5fc5cc5.gif";